export default __webpack_public_path__ + "static/media/i1.f33af5af.png";